import { BadgeColorEnum } from "components/UI/Badge"
import { EWithdrawalStatuses } from "types/withdrawal"

export const ERROR_ADDRESS = "address"
export const ERROR_AMOUNT = "amount"
export const MIN_ADDRESS_LENGTH = 1
export const STATUS_COLORS: Record<EWithdrawalStatuses, BadgeColorEnum> = {
	[EWithdrawalStatuses.NEW]: BadgeColorEnum.BLUE,
	[EWithdrawalStatuses.CONFIRMED]: BadgeColorEnum.ORANGE,
	[EWithdrawalStatuses.VERIFIED]: BadgeColorEnum.ORANGE,
	[EWithdrawalStatuses.PROCESSING]: BadgeColorEnum.ORANGE,
	[EWithdrawalStatuses.DONE]: BadgeColorEnum.GREEN,
	[EWithdrawalStatuses.REFUSED]: BadgeColorEnum.RED,
	[EWithdrawalStatuses.CANCELLED]: BadgeColorEnum.GREY,
}
